import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';
import {awsConfig} from '../../shared/config';

import {setBucket, addToBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';
import * as Security from '../../utils/auth/Security';
import { RoleClient } from '../../components/constants/Consts';


export const employersLoading = (loadCriteria) => ({
    type: ActionTypes.EMPLOYERS_LOADING,
    payload: loadCriteria
});


export const employersFailed = (errmess) => ({
    type: ActionTypes.EMPLOYERS_FAILED,
    payload: errmess
});


export const addEmployers = (employers) => ({
    type: ActionTypes.ADD_EMPLOYERS,
    payload: employers
});


/**
 * Fetch all employers for a clientId.
 * If clientId is null, bring all employers
 * 
 * @returns 
 */
export const fetchEmployersForClient = (clientId) => (dispatch) => {

    if(!clientId)
        return;

    const params = {};

    if( Security.getSignedInUserRole() != RoleClient.UserSpecificEmployer) {
        params.clientId = clientId;
        params.includeSubcontracted = true;
    }
    else {
        const authzE = Security.getAuthorizedEmployersAsRestrictedUser();
        params.erlist = authzE
    }

    const urlParams = new URLSearchParams(params);
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYERS}?${urlParams}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(employersLoading({clientId: clientId}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(employers => dispatch(addEmployers(employers)))
        .catch(error => {
            dispatch(employersFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Angajatorilor" } }));
        });
}


export const fetchEmployer = (employerId) => (dispatch) => {

    if(!employerId)
        return;

    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.EMPLOYERS}/${employerId}`);

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    dispatch(employersLoading({employerId: employerId}));

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(employer => dispatch(addEmployers([employer])))
        .catch(error => {
            dispatch(employersFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul citirii Angajatorului" } }));
        });
}


export const postEmployer = (employer) => (dispatch) => {
    employer.createDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYERS, {
        method: "POST",
        body: JSON.stringify(employer),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(employer => dispatch(addEmployer(employer)))
        .then(employerAction => dispatch(setBucket({ mostRecentEmployerId: employerAction.payload.id })))
        .catch(error => {
            dispatch(employersFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Angajatorului" } }));
        });
}


export const addEmployer = (employer) => ({
    type: ActionTypes.ADD_EMPLOYER,
    payload: employer
});


export const patchEmployer = (employer) => (dispatch) => {
    employer.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYERS + `/${employer.id}`, {
        method: "PATCH",
        body: JSON.stringify(employer),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(employer => dispatch(updateEmployer(employer)))
        .then(eAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Angajatorului au fost salvate cu success!" } })))
        .catch(error => {
            dispatch(employersFailed(error.message))
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Angajatorului" } }));
        });
}


export const updateEmployer = (employer) => ({
    type: ActionTypes.UPDATE_EMPLOYER,
    payload: employer
});


export const deleteEmployer = (employerId) => (dispatch) => {

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.EMPLOYERS + `/${employerId}`, {
        method: "DELETE",
        body: JSON.stringify({}),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                throw error;
            }
        )
        .then(response => response.json())
        .then(() => dispatch(removeEmployer(employerId)))
        .then(eAction => dispatch(addToBucket({ snackbar: { open: true, severity: "success", message: "Datele Angajatorului sterse cu succes" } })))
        .catch(error => {
            dispatch(employersFailed(error.message));
            dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul stergerii Angajatorului" } }));
        });
}


export const removeEmployer = (employerId) => ({
    type: ActionTypes.DELETE_EMPLOYER,
    payload: employerId
});


